<div id="mmc-overview-model">

  <div class="block">
    <label class="labelMmcOverview">
      Model Name: <span class="red">*</span>
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="modelNameTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #modelNameTemplateRef>
        The name you enter is the model name advisors will see in the Model Market Center.
      </ng-template>
    </label>
    <span tooltip [tooltipTitle]="modelNameTooltipMessage" tooltipClass="error" tooltipPosition="right" [tooltipHorizontalOffset]="10">
      <irb-validation-text-box [(value)]="modelMarketName" (change)="validateModelName()"
      width="400px" max="100" [disabled]="data.isProcessing"></irb-validation-text-box>
    </span>

    @if (data.modelMarketId) {
      <span style="padding-left: 20px; ">
        <b>Model ID:</b> {{data.modelMarketId}}
      </span>
    }
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Tax-managed: <span class="red">*</span>
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="taxManagedTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #taxManagedTemplateRef>
        If a model is classified as tax managed, the products within the model - as well as the allocation
        changes - are managed to maximize after-tax investment return with the intention of minimizing
        distributions. These models are managed in a way that makes them more suitable for taxable accounts.
      </ng-template>
    </label>
    <p-radioButton name="TAX_MANAGED" [value]="true" [disabled]="true"
      [(ngModel)]="isTaxManaged"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem1"></p-radioButton>
    <label for="mmcovmodelitem1" [class.p-disabled]="true">Yes</label>
    <p-radioButton name="TAX_MANAGED" [value]="false" [disabled]="true"
      [(ngModel)]="isTaxManaged"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem2"></p-radioButton>
    <label for="mmcovmodelitem2" [class.p-disabled]="true">No</label>
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Asset class: <span class="red">*</span>
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="assetClassTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #assetClassTemplateRef>
        Select an asset class from the list. If you don't see an asset class that correctly represents this
        model, contact your Relationship Manager to have one added.
      </ng-template>
    </label>
    <irb-dropdown-filter #IrbDropdownAssetClass (search)="getAssetClasses($event)" size="30" [value]="assetClass"
      [disabled]="true"
    (selection)="onAssetClassChange($event)"></irb-dropdown-filter>
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Building block style: <span class="red">*</span>
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="bbsTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #bbsTemplateRef>
        <div class="block">The building block style refers to the ETFs or funds that make up this model - e.g.
          active, passive, smart beta, or a mix.
        </div>
        <div class="block">The holdings in active funds may turn over frequently in an attempt to outperform a
          benchmark, while the holdings in passive funds are selected to mimic an index. Smart beta funds use
          a combination of both passive and active strategies while using preset and transparent rules.
        </div>
        <p><strong>Please note:</strong> Individual equities are considered passive.</p>
      </ng-template>
    </label>
    <p-radioButton name="BUILDING_BLOCK_STYLE" value="active" [disabled]="true"
      [(ngModel)]="buildingBlockStyle"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem3"></p-radioButton>
    <label for="mmcovmodelitem3" [class.p-disabled]="true">Active</label>
    <p-radioButton name="BUILDING_BLOCK_STYLE" value="passive" [disabled]="true"
      [(ngModel)]="buildingBlockStyle"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem4"></p-radioButton>
    <label for="mmcovmodelitem4" [class.p-disabled]="true">Passive</label>
    <p-radioButton name="BUILDING_BLOCK_STYLE" value="Smart Beta"
      [disabled]="true"
      [(ngModel)]="buildingBlockStyle"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem5"></p-radioButton>
    <label for="mmcovmodelitem5" [class.p-disabled]="true">Smart Beta</label>
    <p-radioButton name="BUILDING_BLOCK_STYLE" value="mixed" [disabled]="true"
      [(ngModel)]="buildingBlockStyle"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem6"></p-radioButton>
    <label for="mmcovmodelitem6" [class.p-disabled]="true">Mixed</label>
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Used for: <span class="red">*</span>
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="usedForTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #usedForTemplateRef>
        Indicate whether your firm believes this model is best suited for a client's complete strategy, or
        whether this model is best when blended with another model (sleeve).
      </ng-template>
    </label>
    <p-radioButton name="USED_FOR" value="cstrategy" [disabled]="true"
      [(ngModel)]="usedFor"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem7"></p-radioButton>
    <label for="mmcovmodelitem7" [class.p-disabled]="true">Complete Strategy</label>
    <p-radioButton name="USED_FOR" value="sleeve" [disabled]="true"
      [(ngModel)]="usedFor"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem8"></p-radioButton>
    <label for="mmcovmodelitem8" [class.p-disabled]="true">Sleeve</label>
    <p-radioButton name="USED_FOR" value="income" [disabled]="true"
      [(ngModel)]="usedFor"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem9"></p-radioButton>
    <label for="mmcovmodelitem9" [class.p-disabled]="true">Income</label>
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Turnover:
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="turnoverTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #turnoverTemplateRef>
        This is the annual turnover for this model for the previous calendar year. Turnover is calculated by
        taking the total net buys and sells and dividing that by the portfolio (or representative account)
        value.
      </ng-template>
    </label>

    <irb-number-text-box #txtTurnover [(value)]="turnover" places="2"
      [disabled]="true"
      width="80px"
    ></irb-number-text-box>
    &nbsp; %
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Allocation changes: <span class="red">*</span>
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="assetAllocTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #assetAllocTemplateRef>
        Select when the allocation is changed.
      </ng-template>
    </label>
    <irb-dropdown-filter #IrbDropdownAllocChanges (search)="getAllocChanges($event)" size="30"
      [disabled]="true"
      [value]="allocationChangesSel"
    (selection)="onAllocChngChange($event)"></irb-dropdown-filter>
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Risk category: <span class="red">*</span>
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="riskCategoryTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #riskCategoryTemplateRef>
        Select a risk category from the list. Typically, the risk category of the model is defined by the
        model's volatility range.
      </ng-template>
    </label>
    <irb-dropdown-filter #IrbDropdownRiskTolerance (search)="getRiskTolerances($event)" size="30"
      [value]="riskTolerance"
      [disabled]="true"
    (selection)="onRiskCategoryChange($event)"></irb-dropdown-filter>
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Socially responsible: <span class="red">*</span>
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="socRespTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #socRespTemplateRef>
        <div class="block">Socially responsible models are models containing ETFs or mutual funds that hold
          securities in companies that follow certain social, religious, or environmental beliefs.
        </div>
        <div>Schwab does not do any due diligence on this designation; it is solely up to you, the
          investment manager, to ensure that the models are correctly represented.
        </div>
      </ng-template>
    </label>
    <p-radioButton name="SOCIALLY_RESPONSIBLE" [value]="true" [disabled]="true"
      [(ngModel)]="isSociallyResponsible"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem10"></p-radioButton>
    <label for="mmcovmodelitem10" [class.p-disabled]="true">Yes</label>
    <p-radioButton name="SOCIALLY_RESPONSIBLE" [value]="false" [disabled]="true"
      [(ngModel)]="isSociallyResponsible"
    (ngModelChange)="validateEntries()" inputId="mmcovmodelitem11"></p-radioButton>
    <label for="mmcovmodelitem11" [class.p-disabled]="true">No</label>
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Morningstar ID:
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="morningstarTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #morningstarTemplateRef>
        Enter the ID Morningstar has given to this model for tracking purposes. If you don't have a Morningstar
        ID for this model, please contact your Relationship Manager for more information.
      </ng-template>
    </label>
    <input type="text" pInputText
      tooltip
      [tooltipTitle]="msidIdTooltipMessage"
      [tooltipPosition]="'right'"
      tooltipClass="error"
      (input)="onMorningstarChange()"
      [tooltipHorizontalOffset]="8"
      style="width: 120px;" [(ngModel)]="morningStarId"
      maxlength="25"
      (change)="validateEntries()"
      (blur)="validateEntries()"
      [disabled]="data.isProcessing"
      >
    <span style="padding-left: 5px;">
      A Morningstar ID <b>OR</b> Informa ID is required <span class="red">*</span>
    </span>
  </div>

  <div class="block">
    <label class="labelMmcOverview">
      Informa PSN ID:
    </label>
    <irb-validation-text-box #psnid [(value)]="sourceId" regExp="^[0-9]+$"
      [disabled]="!userDetails.isMMCAdmin"
      (valueChange)="validateEntries()"
      invalidMessage="Please enter 3 to 9 digit." width="120px"
    min="3" max="9"></irb-validation-text-box>
  </div>

</div>
